export default "/images/aros.webp?c4c480614ac71fb26d0553326844c792";